import { Stack, Checkbox, Typography } from "@mui/material";
// import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";

const statusOptions = [
  { key: "complete", label: "C", color: "green" },
  { key: "incomplete", label: "IC", color: "orange" },
  { key: "late", label: "L", color: "blue" },
  { key: "missing", label: "M", color: "red" },
];

export default function CheckHomework({ editData }) {
  const currentStatus = editData?.status ?? "empty";

  return (
    <Stack
      spacing={2.5}
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      {statusOptions.map(({ key, label, color }) => (
        <Stack direction="row" alignItems="center" key={key}>
          <Checkbox
            checked={currentStatus === key}
            inputProps={{ "aria-label": `${label} status` }}
            sx={{
              color: color,
              "&.Mui-checked": {
                color: color,
              },
            }}
          />
          <Typography>{label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
